import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-org_new",
  "use": "icon-org_new-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-org_new\"><defs><style type=\"text/css\"></style></defs><path d=\"M950.857143 438.857143H585.142857V73.142857H438.857143v365.714286H73.142857v146.285714h365.714286v365.714286h146.285714V585.142857h365.714286V438.857143z\" fill=\"#91A0AF\" p-id=\"2033\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol